module.exports = "/_next/static/images/PaidSubscriptionAcquisitionDesktop-9cd529be56ababfa8822c7a9c555244f.webp";